export function getTablePagination(settings) {
  let size = settings.size || 5;
  const { currentPage, totalRows, rowsPerPage } = settings;
  const pad = Math.floor(size / 2);
  let pageList;
  let min;
  let max;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  size = (size > totalPages) ? totalPages : size;

  if (currentPage < pad + 1) {
    min = 1;
    pageList = range(min, size + 1);
  } else if (currentPage > pad && currentPage < totalPages - pad + 1) {
    min = currentPage - pad;
    pageList = range(min, currentPage + pad + 1);
  } else {
    min = totalPages - size + 1;
    pageList = range(min, totalPages + 1);
  }

  const showFirst = currentPage > pad + 1 || (currentPage === totalPages && totalPages > 1);
  const showLast = currentPage < totalPages;
  min = (currentPage - 1) * rowsPerPage + 1;
  max = currentPage * rowsPerPage;
  max = (max > totalRows) ? totalRows : max;

  return { totalPages, pageList, min, max, showFirst, showLast };
}

function range(start, end) {
  return Array.from({ length: end - start }, (_, i) => i + start);
}

export function getRowRange(page, rows) {
  let min = 0;
  let max = 9;
  let length = 10;

  if (page > 1) {
    min = (page - 1) * 10;
    if (page * 10 > rows.length) {
      // last page
      max = rows.length - 1;
      length = rows.length - min;
    } else {
      // all other pages
      max = min + 10 - 1;
      length = 10;
    }
  }
  return { min, max, length };
}

export function padOrderResults(results, currentPage, itemsPerPage) {
  const { rows } = results;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paddedRows = Array.from({ length: results.totalItems }, () => ({}));
  for (let i = 0; i < rows.length; i++) {
    paddedRows[startIndex + i] = rows[i];
  }
  return paddedRows;
}

export function getResultSlice(results, currentPage, rowsPerPage) {
  const begin = (currentPage - 1) * rowsPerPage;
  const end = begin + rowsPerPage;
  return results?.length ? results.slice(begin, end) : [];
}

export function toCamelCase(str) {
  return str
    .replace(/\s(.)/g, $1 => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, $1 => $1.toLowerCase());
}

export function toDotSeparator(str) {
  return str
    ?.replace(/\s(.)/g, $1 => $1.toLowerCase())
    ?.replace(/\s/g, '.')
    ?.replace(/^(.)/, $1 => $1.toLowerCase());
}

export function toNormalCase(str){
  return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase();
}
